import { render } from "./BaseTop.vue?vue&type=template&id=cdfc64e6&scoped=true"
const script = {}

import "./BaseTop.vue?vue&type=style&index=0&id=cdfc64e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfc64e6"]])

export default __exports__